import React from "react";
import PropTypes from "prop-types";

const FailureReasonSelector = ({
  disabled,
  value,
  handleChangeFailureReason,
  metadataId = null,
  isReprise = false,
}) => {
  return (
    <select
      disabled={disabled}
      className="failure-reason-selector"
      name="failure_reason"
      value={value}
      onChange={(e) => {
        handleChangeFailureReason(e.target.value, metadataId);
      }}
    >
      <option value="" />
      {isReprise ? (
        // Options for reprise
        <>
          <option value="customerRequest">
            Produit non repris à la demande du client
          </option>
          <option value="noProductToPickup">
            Il n&apos; y a plus de produit à reprendre
          </option>
          <option value="notUninstalled">
            Le produit n&apos;est pas désinstallé
          </option>
          <option value="badHygiene">Mauvais état hygiénique</option>
          <option value="dismantledProduct">Appareil / produit désossé</option>
          <option value="other">Autre...</option>
        </>
      ) : (
        // Original options for non-reprise
        <>
          <option value="closed">
            Ne peut pas être livré dans la pièce de destination
          </option>
          <option value="damaged">Produit abimé</option>
          <option value="refused">Produit refusé par le client</option>
          <option value="customerCancellation">
            Produit annulé par le client
          </option>
          <option value="partialDelivery">Colis manquant</option>
          <option value="missingInfo">Information ou document manquant</option>
          <option value="notready">Produit non prêt (enlèvement)</option>
        </>
      )}
    </select>
  );
};

FailureReasonSelector.propTypes = {
  disabled: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
  metadataId: PropTypes.string,
  handleChangeFailureReason: PropTypes.func.isRequired,
  isReprise: PropTypes.bool,
};

export default FailureReasonSelector;
